import { connect } from 'react-redux'
import Component from 'components/NotFound'

export default connect()(Component)
